import React from 'react';
import ReactLoading from 'react-loading';
 
const loadingspin = () => (
    <ReactLoading type="spinningBubbles" color="black" height="64px" width="64px" />
);
 
export default loadingspin;